import React from "react";
import ExistingUserLayoutHeader from "./ExistingUserLayoutHeader";

const ExistingUserLayout = ({ children, isVineCrm }: any) => {
  return (
    <div>
      <ExistingUserLayoutHeader isVineCrm={isVineCrm} />

      {children}
    </div>
  );
};

export default ExistingUserLayout;
